export const UNINITIALIZED = 'UNINITIALIZED';

// SMS
export const REGISTER_SMS = 'REGISTER_SMS';
export const VERIFY_SMS = 'VERIFY_SMS';
export const CHANGE_SECURITY_NUMBER = 'CHANGE_SECURITY_NUMBER';
export const VERIFICATION_SUCCESSFUL = 'VERIFICATION_SUCCESSFUL';